module.exports = __webpack_public_path__ + "static/media/HelveticaNeueMedium.0a13c540.ttf";